// NumericPad.jsx
import React from "react";
import { Delete } from "react-feather";

export default function NumericPad({ value, onChange }) {
  const addDigit = (d) => onChange(value + d);
  const removeDigit = () => onChange(value.slice(0, -1));
  const clearAll = () => onChange("");

  const btnStyle = {
    width: "55px",
    height: "55px",
    fontSize: "1.4rem",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#ffffff",
    border: "1px solid #d0d4dc",
    boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
    cursor: "pointer",
    userSelect: "none",
    margin: "6px",
  };

  const btnStyleRemove = {
    width: "55px",
    height: "55px",
    fontSize: "1.4rem",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "var(--bs-danger-bg-subtle)",
    color: "var(--bs-danger-text-emphasis, #fff)",
    border: "1px solid var(--bs-danger)",
    boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
    cursor: "pointer",
    userSelect: "none",
    margin: "6px",
  };

  const rowStyle = {
    display: "flex",
    justifyContent: "center",
  };

  return (
    <div style={{ width: "100%", textAlign: "center", marginTop: "5px" }}>
      <div style={rowStyle}>
        <div style={btnStyle} onClick={() => addDigit("1")}>1</div>
        <div style={btnStyle} onClick={() => addDigit("2")}>2</div>
        <div style={btnStyle} onClick={() => addDigit("3")}>3</div>
      </div>

      <div style={rowStyle}>
        <div style={btnStyle} onClick={() => addDigit("4")}>4</div>
        <div style={btnStyle} onClick={() => addDigit("5")}>5</div>
        <div style={btnStyle} onClick={() => addDigit("6")}>6</div>
      </div>

      <div style={rowStyle}>
        <div style={btnStyle} onClick={() => addDigit("7")}>7</div>
        <div style={btnStyle} onClick={() => addDigit("8")}>8</div>
        <div style={btnStyle} onClick={() => addDigit("9")}>9</div>
      </div>

      <div style={rowStyle}>
        <div style={{ ...btnStyle, fontSize: "1.1rem" }} onClick={clearAll}>C</div>
        <div style={btnStyle} onClick={() => addDigit("0")}>0</div>
        <div style={btnStyleRemove} onClick={removeDigit}>
          <Delete size={22} />
        </div>
      </div>
    </div>
  );
}
